import React from 'react';
import styled from 'styled-components';
import toolClient from '@requests/telnyx/tools.requests';

import { useQuery } from '@tanstack/react-query';
import { AITool } from '../../tool.types';
import { RequestError } from '@requests/common';
import { useParams } from 'react-router-dom';
import { Select } from '@common/Select';
import { Loader } from '@common/hooks/useLoader';
import { Stack } from '@mui/material';
import { Label } from '@common/Label';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 1rem;
`;

interface Props {
  toolName: string;
  toolChoice: string;
  setToolChoice: React.Dispatch<React.SetStateAction<string>>;
}

export const SettingToolChoice: React.FC<Props> = ({ toolName, toolChoice, setToolChoice }) => {
  const { assistantId } = useParams();

  const { data: flowTools = [], isLoading: flowToolsLoading } = useQuery<
    AITool[],
    RequestError,
    AITool[],
    [string, string | undefined]
  >({
    queryKey: ['ai_assistants_tools', assistantId],
    queryFn: toolClient.list,
    retry: false,
  });

  const staticOptions = [
    { label: 'auto', value: 'auto' },
    { label: 'none', value: 'none' },
  ];

  const toolOptions = flowTools
    .map((tool) => tool.name)
    .filter((name) => name !== toolName)
    .map((name) => ({ label: name, value: name }));

  const options = staticOptions.concat(toolOptions);

  return (
    <Container>
      {flowToolsLoading && <Loader />}
      {!flowToolsLoading && (
        <Stack spacing={1}>
          <Label
            title='Next Tool Choice'
            tooltip='You can set this value to force the LLM to execute this tool next before responding.'
          />
          <Select value={toolChoice} options={options} onChange={(e) => setToolChoice(e.target.value)} />
        </Stack>
      )}
    </Container>
  );
};
